module.exports = __webpack_public_path__ + "static/media/home2.f85b7176.png";